'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResizeWatcher = require('./ResizeWatcher');

Object.defineProperty(exports, 'ResizeWatcher', {
  enumerable: true,
  get: function get() {
    return _ResizeWatcher.ResizeWatcher;
  }
});


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/ResizeWatcher/index.js